import React from "react";
import { NavLink } from "react-router";
import styles from "./Header.module.css";
import logoPNG from "../assets/MSRWF Logo 1.png";

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={styles.headerLogoSection}>
          <div className={styles.logoImage}>
            <img src={logoPNG} alt="MSRWF Logo" />
          </div>
          <h1 className={styles.organizationName}>
            Mississippi Roadworker's Foundation
          </h1>
        </div>

        <nav className={styles.headerNav}>
          <NavLink
            to="/"
            className={({ isActive }) =>
              `${styles.navButton} ${isActive && styles.activeButton}`
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `${styles.navButton} ${isActive && styles.activeButton}`
            }
          >
            Contact
          </NavLink>
          <NavLink
            to="/donate"
            className={`${styles.navButton} ${styles.donateButton}`}
          >
            Donate
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;
